var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: _vm.$style.joinWhy,
      style: {
        backgroundImage: "url('" + _vm.assets.WhyBackground + "')"
      }
    },
    [
      _c(
        "JoinHeading",
        { staticClass: "text-white mb-7 text-center", attrs: { level: 1 } },
        [_vm._v("\n    " + _vm._s(_vm.$t("join.section.why.title")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "PageCollectionCarousel",
        { attrs: { align: "center" } },
        _vm._l(_vm.items, function(item) {
          return _c("GraphicalCardItem", {
            key: item.image,
            staticClass: "text-center bg-white",
            class: _vm.$style.item,
            attrs: { item: item }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }